const fr = {
  9000001: "Trophée de Noël 2023",
  9000002: "Championnat de Futures SuperEx",
  9000003: "gagnez 30,000 USDT en prix de compétition ",
  9000004: "Nombre de participants",
  9000005: "Cagnotte débloquée (USDT)",
  9000006: "Qualification pour le classement du volume de transactions ",
  9000007: "Qualifications basées sur le Classement du Taux de Profit",
  9000008: "Compétition de qualification pour le classement des profits ",
  9000009: `Compétition de classement du volume de transactions : Débloquez la plus haute récompense de <span style="color: #ffc72b;">20,000</span> USDT dans la cagnotte bonus`,
  9000010: "Selon le nombre de participants, plus le nombre de participants est élevé, plus la cagnotte sera débloquée, jusqu'à 20 000 USDT",
  9000011: "Montant du fonds de prix",
  9000012: "Mises à jour quotidiennes à 10:00 (UTC) pendant l'événement",
  9000013: "Estimation des récompenses",
  9000014: "Volume total des transactions sur les contrats à terme pendant la période",
  9000015: "Règles des récompenses",
  9000016: "Selon le nombre de participants, plus le nombre de participants est élevé, plus la cagnotte sera débloquée, jusqu'à 20 000 USDT",
  9000017: "Montant du fonds de prix (USDT)",
  9000018: "Classement du taux de profit de l'événement",
  9000019: "Inscription",
  9000020: "Classement du montant des profits de l'événement",
  9000021: "Terminé",
  9000022: `Concours de classement par taux de profit, partagez un fonds de prix de <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
  9000023: `Compétition de classement des profits - Profitez de la prime de <span style="color: #ffc72b;">{moneyPond}</span> USDT`,
  9000024: "Taux de profit cumulé sur les contrats à terme",
  9000025: "Montant total des profits accumulés",
  9000026: "Pas Commencé",
  9000027: "Les 50 meilleurs participants de la compétition de classement des profits seront récompensés. Pour plus de détails, veuillez vous référer aux règles de récompense pour le classement afin d'obtenir les récompenses",
  9000028: "Les 50 premiers du classement en taux de profit des utilisateurs participants peuvent recevoir des prix, voir les règles de récompense basées sur le classement des transactions",
  9000029: "Classement du volume de transactions de l'événement",
  9000030: "inscription réussi",
  9000031: "Télécharger l'application",
  9000032: "Retour à la page d'accueil",

  //合约交易积分
  9100001: "Enregistrer des Points",
  9100002: "Obtenir un Airdrop",
  9100003: "Échanger des Récompenses",
  9100004: "Solde des Points",
  9100005: "Détails",
  9100006: "Points de Connexion",
  9100007: "Points de Trading",
  9100008: `Points d'Invitation`,
  9100009: "Points Bonus",
  9100010: "Tirage au Sort",
  9100011: "Obtenez des points",
  9100012: "Règles des Points",
  9100013: "Détails des points",
  9100014: "Vous devez vous inscrire pour participer à cet événement. Cliquez pour vous inscrire",
  9100015: "A tradé pendant {day} jours consécutifs et gagné {num} points",
  9100016: `Points gagnés aujourd'hui {num}`,
  9100017: "Fond de Prix en Points",
  9100018: "Chaque tirage au sort consomme {point} points, et un maximum de {num} tirages au sort peut être effectué par jour.",
  9100019: `Nombre de tirages au sort aujourd'hui`,
  9100020: "Utilisateur",
  9100021: "Points",
  9100022: "Le solde des points est insuffisant",
  9100023: "Le solde des points est insuffisant. Veuillez obtenir des points avant de participer au tirage au sort.",
  9100024: "Le nombre de tirages au sort a atteint sa limite !",
  9100025: `Le nombre de tirages au sort pour aujourd'hui a atteint sa limite. Réessayez demain.`,
  9100026: "Comment obtenir des points",
  9100027: `Inscrivez-vous pour participer à l'activité de gain de points de trading de contrats à terme afin de gagner des points.`,
  9100028: "Inscription réussie",
  9100029: `Vous vous êtes inscrit pour participer à l'activité de trading de contrats à terme afin de gagner des points. Allez et tradez pour gagner plus de points (vous ne bénéficierez plus des commissions et des remises en argent)`,
  9100030: "Après avoir annulé votre inscription, vous ne recevrez plus de points. Êtes-vous sûr de vouloir annuler votre inscription ?",
  9100031: `Centre d'Activités des Points de Trading`,
  9100032: "Obtenez des points",
  9100033: "Vous devez vous inscrire pour participer à cet événement. Cliquez pour vous inscrire",
  9100034: "Vous pouvez gagner des points en tradant des contrats à terme de manière continue",
  9100035: "Les utilisateurs peuvent gagner des points pour tous leurs échanges de contrats à terme",
  9100036: "Points du classement",
  9100037: "Les cinq premiers utilisateurs du classement des échanges quotidiens recevront des points bonus supplémentaires",
  9100038: `Les utilisateurs invités reçoivent des points et l'invitant peut recevoir des points bonus.`,
  9100039: '{guy} Déjà gagné<span style="color:#D9A31A"> {num} points!</span>',
  9100040: "Essayez la Loterie Maintenant !",
  9100041: "Félicitations pour avoir obtenu",
  9100042: "Tous les types",
  9100043: "Restez sur cette page",
  9100044: "Inscrivez-vous pour participer",
  9100045: "Continuez à trader",
  9100046: `Il n'y a actuellement aucune activité en cours. Restez à l'affût des dernières nouvelles...`,
  9100047: "Échanger des jetons SCS",
  9100048: "",
  9100049: "",

  9100050: "Dates",
  9100051: "Sélectionner une date de début",
  9100052: "Sélectionner une date de fin",
  9100053: "à",
  9100054: "Type",

  9100055: "Points gagnés = volume de trading * 1% (la difficulté sera ajustée au fur et à mesure que le volume total de trading de la plateforme augmente)",
  9100056: `Par exemple : si l'utilisateur utilise une position avec une marge de 100 USDT*100X=10000 USDT`,
  9100057: `alors vous n'avez besoin que d'un dépôt de 100 USDT pour obtenir 100 points.`,
  9100058: `Les points de trading sont le seul moyen d'obtenir le token de plateforme SCS`,
  9100059: "Points bonus supplémentaires = total des points de la journée * ratio de récompense de classement.",
  9100060: "Rang",
  9100061: "Première place",
  9100062: "Deuxième place",
  9100063: "Troisième place",
  9100064: "Quatrième place",
  9100065: "Cinquième place",
  9100066: `Les utilisateurs invités reçoivent des points et l'invitant peut recevoir des points bonus.`,
  9100067: "Facteur de niveau",
  9100068: `Formule de calcul : points de parrainage obtenus = points obtenus par l'invité * coefficient de niveau`,
  9100069: "Le coefficient de niveau sera ajusté selon la situation réelle.",
  9100070: `Par exemple : l'utilisateur B participe à une activité de points, et son invitant est l'utilisateur A, et le nombre d'invitations de l'utilisateur A a atteint le niveau 3. L'utilisateur B a accumulé des points = 360 000;`,
  9100071: `Alors les points de promotion cumulés que l'utilisateur A peut obtenir = 360 000 * 30% = 108 000`,
  9100072: "coefficient de récompense",
  9100073: "1 Utilisateurs de trading",
  9100074: "Le volume de trading atteint 5 millions",
  9100075: "Le volume de trading atteint 20 millions",

  9100076: "Transfert",

  //热币
  9100080: "Terminé",
  9100081: `Cliquez sur « S'inscrire maintenant » pour gagner des récompenses`,
  9100082: "Afficher les règles",
  9100083: "Adhérer maintenant",
  9100084: "Activité",
  9100088: "Commerce",
  9100089: "Dépôt",
  9100090: "Vous êtes déjà inscrit.",

  9100091: "Cette activité est terminée, veuillez attendre la prochaine activité !",
  9100092: `L'événement n'a pas encore commencé, veuillez rester à l'écoute.`,
  9100093: "",
  9100094: "",

  //api key
  9100105: "Créer une clé API",
  9100106: "Consulter la Documentation API",
  9100107: "Système de commerce intégré",
  9100108: "Créer/Gérer une clé API",
  9100109: `Déployer l'API`,
  9100110: "Commerce et Demandes",
  9100111: "Plateforme de premier plan pour les actifs numériques",
  9100112: "Une large gamme de services de commerce et de gestion des actifs numériques pour répondre à des besoins commerciaux diversifiés.",
  9100113: "Offrir de meilleurs services",
  9100114: "Des frais de transaction plus favorables, des montants de transaction plus élevés, des fonctions de gestion de compte plus flexibles, etc.",
  9100115: `Le choix de millions d'utilisateurs`,
  9100116: "Assurer un environnement commercial sécurisé, fournir un support client professionnel, vous aider à avancer de manière stable dans le monde des actifs numériques.",
  9100117: "Comment créer une clé API chez SuperEx ?",
  9100118: "Où puis-je consulter la documentation API de SuperEx ?",
  9100119: "Que faire si vous rencontrez des problèmes avec les transactions SuperEx ?",
  9100120: `Comment utiliser l'API de SuperEx ?`,
  9100121: `Accédez à l'API SuperEx pour un commerce plus rapide et plus fluide`,
  9100122: `Lorsque vous êtes connecté, placez le curseur sur l'avatar - 'Gestion API' et cliquez sur 'Créer une clé API' pour créer votre clé API chez SuperEx. Note : Si vous n'êtes pas connecté, vous devez d'abord vous connecter à votre compte SuperEx.
Vous pouvez également créer votre clé API depuis le lien 'APIs' dans la barre de navigation inférieure.`,
  9100123: 'Vous pouvez cliquer sur <a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com/en/quickStart.html">Documentation API</a> pour consulter la documentation API de SuperEx.',
  9100124: `Si vous rencontrez des problèmes ou avez des suggestions lors de l'utilisation, vous pouvez nous contacter de la manière suivante : <br>Contacter le service clientèle via le "Centre d'aide" sur le site officiel ou en envoyant un e-mail à support@superex.com.`,
  9100125: `Pour utiliser l'API de SuperEx, vous devez d'abord :<br>
Vous inscrire et vous connecter à votre compte SuperEx.<br>
Créer une clé API, ce qui générera pour vous un access_key et un secret_key.<br>
Utilisez cet access_key et ce secret_key pour signer vos demandes.<br>
Selon vos besoins, vous pouvez utiliser diverses API fournies par SuperEx, telles que l'API de données de marché, l'API de trading, et l'API de compte. Assurez-vous que chaque demande suit les instructions dans la documentation API, avec les en-têtes HTTP et les signatures appropriés.`,
  9100126: "Action",
  9100127: "Créer une nouvelle clé API",
  9100128: "Nom de la clé API",
  9100129: "Veuillez entrer un nom de clé API",
  9100130: "Permissions (Choix multiples)",
  9100131: "Lire",
  9100132: "Commerce",
  9100133: `Liste blanche d'adresses IP (facultative)`,
  9100134: `Vous pouvez lier jusqu'à 10 adresses IP à chaque clé API, séparées par des virgules.`,
  9100135: `J'ai lu et j'accepte les`,
  9100136: `J'ai lu et j'accepte l'Avis de Risque Utilisateur API`,
  9100137: "Créer",
  9100138: `SuperEx vous fournit une API puissante qui vous permet d'utiliser des services tels que la requête de marché et le commerce automatique. Voyez comment l'utiliser en consultant la <a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com/en/quickStart.html">Documentation API</a>.`,
  9100139: `Chaque compte peut créer jusqu'à 10 clés API.`,
  9100140: `Les clés API qui ne sont pas liées à une IP expireront automatiquement après 90 jours. Si vous avez l'intention de les utiliser à long terme, vous pouvez renouveler votre clé API sous 'Ma clé API' — 'Action' — 'Renouveler', prolongeant la période de validité de 90 jours supplémentaires. Les clés API liées à des IP n'ont pas de limite d'expiration.`,
  9100141: "Ma clé API",
  9100142: "Permissions",
  9100143: "Adresse IP",
  9100144: "Renouveler",
  9100145: `La création d'une clé API nécessite que vous déposiez n'importe quel montant dans votre portefeuille au comptant pour activer votre compte`,
  9100146: "Confirmer le renouvellement de la clé API actuelle",
  9100147: `Ne divulguez pas votre clé d'accès et votre clé secrète afin d'éviter une perte d'actifs.`,
  9100148: "Pour des raisons de sécurité, il est recommandé de lier les clés API à des adresses IP spécifiques. Une clé API peut être liée à un maximum de 20 adresses IP ou segments IP. Vous pouvez saisir une seule adresse IP ou plusieurs adresses directement, et séparer les différentes adresses par une virgule. Par exemple : 192.168.1.1,192.168.1.2",
  9100149: `Après un renouvellement réussi, la date d'expiration sera recalculée. Si vous utilisez la clé API à long terme, il est recommandé de lier une adresse IP. Les clés API liées ne expirent pas et sont également plus sécurisées.`,
  9100150: "Confirmer la suppression de la clé API actuelle ?",
  9100151: "Vous devez comprendre les risques suivants :",
  9100152: "Votre clé API est étroitement liée à la sécurité de votre compte. Toute personne connaissant votre clé API pourrait potentiellement contrôler les actifs de votre compte. Par conséquent, veuillez la protéger correctement, ne divulguez pas votre clé API à des tiers, et ne la téléchargez pas sur des sites Web ou forums tiers.",
  9100153: `Si votre clé API est divulguée pour des raisons personnelles, y compris, mais sans s'y limiter, les problèmes de sécurité des actifs et les pertes économiques, vous assumerez toutes les responsabilités qui en découlent, et nous n'assumerons aucune responsabilité.`,
  9100154: "Avis de risque",
  9100155: "Je suis conscient et prêt à assumer le risque.",
  9100156: "Sauvegardé",
  9100157: "Permissions",
  9100158: "La clé secrète est affichée une seule fois et ne peut être récupérée en cas de perte, veuillez la conserver en sécurité.",
  9100159: `Ne divulguez pas votre clé d'accès et votre clé secrète afin d'éviter une perte d'actifs.`,
  9100160: "Si vous oubliez votre clé secrète, veuillez supprimer cette paire de clés et en demander une nouvelle.",
  9100161: `Nous offrons des API puissantes pour vous aider à intégrer efficacement les fonctionnalités de trading dans vos applications. Les API sont catégorisées en Compte, Trading, et Données de Marché, vous permettant de configurer les permissions nécessaires et d'implémenter le trading automatisé via API.`,
  9100162: "Date de cotation",
  9100163: "Créer une nouvelle clé API",
  9100164: "Modifier",
  9100165: `Date d'échéance`,
  9100166: "Supprimer",
  9100167: "Création réussie",
  9100168: "Conseils",
  9100169: `D'accord`,
  9100170: `Avis de risque pour l'utilisateur de l'API`,
  9100171: `Format d'adresse IP incorrect`,
  9100172: "",
  //自由区二维码分享页面
  91000951: "Spot Meme, un monde crypto des utilisateurs, par les utilisateurs, pour les utilisateurs.",
  91000961: `Ouvrir l'application`,
  //自由区二维码分享页面
  9100095: "SuperEx Free Market, un monde crypto des utilisateurs, par les utilisateurs, pour les utilisateurs.",
  9100096: `Ouvrir l'application`,
  9100097: "",
  9100098: "",

  //代理商
  101738: "Devenez un agent SuperEx et profitez de commissions élevées !",
  101739: "Invitez vos amis à trader avec SuperEx et obtenez 50 % de commission. Commencez à gagner des commissions après que vos références aient négocié des contrats.",
  101740: "Devenir un agent",
  101741: "Comment puis-je obtenir des commissions ?",
  101742: "Demandez à devenir un agent",
  101743: `Si vous avez une communauté, des médias ou d'autres ressources, vous pouvez demander à devenir un agent, et après une demande réussie, vous pouvez passer au statut d'agent.`,
  101744: "Promouvoir SuperEx",
  101745: `Partagez votre lien d'invitation avec votre communauté, vos followers ou vos autres canaux pour une exposition promotionnelle`,
  101746: "Obtenez une commission",
  101747: `Vous pouvez gagner des commissions lorsque de nouveaux utilisateurs s'inscrivent et échangent grâce à votre lien d'invitation.`,
  101748: "Combien de commissions puis-je gagner ?",
  101749: `Lorsque vous invitez des utilisateurs à trader avec SuperEx, vous obtenez 20 % de la commission de votre ami sous forme de bonus d'invitation.`,
  101750: `Si vous devenez un agent SuperEx, vous recevrez également un bonus d'agent de 50 %. `,
  101751: "Pourquoi devenir un courtier SuperEx ?",
  101752: "Commissions élevées",
  101753: "Remise de commission de 50 %",
  101754: "Support de trafic utilisateur",
  101755: "Support de trafic professionnel, accès facile aux revenus",
  101756: "Support de marque",
  101757: "Événements hors ligne mondiaux avec cadeaux périphériques personnalisés",
  101758: "Événements hors ligne mondiaux",
  101759: `Réunion mondiale des fans de SuperEx, réunions de haut niveau de l'industrie et soutien à tous les agents pour les aider à augmenter leurs gains !`,
  101760: "Examen échoué",
  101761: "Agents",
  101762: "Gestion des canaux",
  101763: "Créer un canal",
  101764: "Canaux affiliés",
  101765: "Méthode de promotion",
  101766: "Nom du canal",
  101767: "Créé",
  101768: "Modifier",
  101769: "Taux de remise sur les contrats à terme",
  101770: "Taux de remise au comptant",
  101771: "Gestion de la promotion",
  101772: `Code d'invitation`,
  101773: `Code d'invitation`,
  101774: "Nombre restant de liens de parrainage pouvant être créés",
  101775: "Amis",
  101776: `Code d'invitation de l'agent`,
  101777: "Nombre de références des agents",
  101778: `Codes d'invitation réguliers`,
  101779: "Nombre de références régulières",
  101780: `Lien d'invitation`,
  101781: "Canaux réguliers",
  101782: "Tableau de Données",
  101783: "Dépôts",
  101784: "Montant de la transaction",
  101785: "Commission",
  101786: `Code d'invitation`,
  101787: `Relation d'invitation mobile`,
  101788: "Rapports de contrat",
  101789: "Rapports spot",
  101790: "Transactions",
  101791: "Centre de règlement",
  101792: "Règlement des contrats",
  101793: "Règlement des spots",
  101794: "Commission estimée",
  101795: "Historique des retraits",
  101796: "Voir les actifs",
  101797: "Montant retiré",
  101798: "Commission cumulée",
  101799: `Les jetons actuels ne correspondent pas au montant de retrait. Vous pouvez inviter plus d'utilisateurs à trader pour obtenir de l'argent bonus.`,
  101800: "Aperçu des données du contrat",
  101801: "Aperçu des données spot",
  101802: "Détails du contrat",
  101803: "Détails spot",
  101804: "Toutes directions",
  101805: `Commission estimée de l'agent`,
  101806: `Commission estimée de l'utilisateur`,
  101807: "Heure de la transaction",
  101808: `Pour les règles détaillées, veuillez consulter l'annonce SuperEx.`,
  101809: `Formulaire de demande de programme d'agent`,
  101810: "Votre langue",
  101811: "Dans quel pays êtes-vous ? (Exemple : Iran)",
  101812: "Quelle est votre principale plateforme/canal ?",
  101813: "Combien de followers/fans/utilisateurs avez-vous sur votre plateforme/réseaux sociaux/site web ?",
  101814: `Remplissez le lien de votre principale plateforme/canal (entrez l'URL complète)`,
  101815: `Autres liens de canaux sociaux/site web (entrez l'URL complète)`,
  101816: "Votre nom",
  101817: "Entrez les canaux de médias sociaux pour vous contacter rapidement (par exemple, Telegram id @xxx)",
  101818: `Où avez-vous entendu parler du programme d'agent ?`,
  101819: "Amis",
  101820: "Informations supplémentaires que vous pouvez partager avec nous, comme vous-même et une brève présentation de votre canal",
  101821: "Super !",
  101822: "Votre demande pour devenir un agent SuperEx a été soumise avec succès. Une fois approuvée, nous vous en informerons par e-mail.",
  101823: "La durée de la période ne peut pas dépasser 3 mois",
  101824: "Succès",
  101825: "Tous les Retraits",
  101826: "Retiré",
  101827: `Les jetons actuels ne correspondent pas au montant de retrait. Vous pouvez inviter plus d'utilisateurs à trader pour obtenir de l'argent bonus.`,
  101828: "Gestion des utilisateurs",
  101829: "ID utilisateur",
  101830: "Taux de Remise Contrats à Terme",
  101831: "Taux de Remise Spot",
  101832: `Date d'inscription`,
  101833: "Détails de la transaction",
  101834: "Acheter long",
  101835: "Vendre Short",
  101836: "Vendre long",
  101837: "Acheter Short",
  101838: "Date de retrait",
  101839: "Devise de retrait",
  101840: "Nombre de retraits",
  101841: "Commission",
  101842: "Montant retirable",
  101843: "Retrait",
  101844: "Communauté",
  101845: "E-mail (cet e-mail sera utilisé pour recevoir des informations sur les agents, veuillez vérifier votre courrier indésirable si vous ne trouvez pas le message de vérification)",
  101846: "Code de vérification",
  101847: `Soyez patient, nous examinons votre demande. Nous vous notifierons par e-mail une fois qu'elle sera approuvée.`,
  101848: `Désolé, votre demande d'agent n'a pas été approuvée`,
  101849: "Soumettre à nouveau",
  101850: "Aperçu des données",
  101851: "Taux de commission du contrat des agents",
  101852: "Taux de commission spot des agents",
  101853: `Vous avez été disqualifié en tant qu'agent, si vous avez des questions, veuillez contacter l'administrateur.`,
  101854: "Tout le temps",
  101855: "Hier",
  101856: "Ce Mois-ci",
  101857: "Le Mois Dernier",
  101858: "Nombre de Traders",
  101859: "Dépôt Total",
  101860: `Sélectionnez le code d'invitation.`,
  101861: "Gains Bruts",
  101862: "Commission Contrats à Terme",
  101863: "Commission Spot",
  101864: "En Attente",
  101865: "Retiré",
  101866: "À déverrouiller",
  101867: "* Les gains de commission doivent être retirés sur Mon Compte Spot pour être utilisés.",
  101868: "Confirmation de Retrait",
  101869: "Êtes-vous sûr de vouloir retirer tous les jetons sur mon Compte Spot ?",
  101870: `Les jetons actuels ne correspondent pas au montant de retrait. Vous pouvez inviter plus d'utilisateurs à trader pour obtenir de l'argent bonus.`,
  101871: "Débloqué",
  101872: "Inversé",
  101873: `Qualification d'agent annulée.`,
  101874: "Déjà un agent",
  101875: `Vue d'ensemble des données du canal`,
  101876: `Données de l'utilisateur`,
  101877: "Vers portefeuille cloud Compte à terme",
  101878: "Vers le compte Spot du portefeuille cloud",
  101879: "Détails du trading Spot",
  101880: "Détails du trading Futures",
  101881: "Centre de règlement des contrats à terme",
  101882: "Centre de règlement des transactions de gré à gré",
  101883: `Rapport d'efficacité.`,
  101884: "Sélectionnez la langue.",
  101885: "Saisissez votre réponse.",
  101886: "Sélectionnez le nom du canal.",
  101887: "Retrait de commission",
  101888: "Entrer le nom du canal",
  101889: "Sélectionnez la méthode de promotion.",
  101890: "Saisissez des notes.",
  101891: "Actifs disponibles pour retrait",
  101892: "Confirmer le retrait",
  101893: `Définir le taux de remise sur les contrats à terme de l'utilisateur`,
  101894: `Définir le taux de remise sur les spots de l'utilisateur`,
  101895: "Rapport de performance des contrats à terme",
  101896: "Rapport de performance des spots",
  101897: "Conversion (USDT)",
  101898: "Withdrawal to Cloud Wallet",
  101899: "Are you sure you want to withdraw all your spot commissions to your cloud wallet?",
  101900: "Voir les fonds",
  101901: "Toutes les devises",
  101902: "Non retiré",
  101903: "Commission totale",
  101904: "sélectionner un pays ou une région",
  101905: "Saisissez le code de vérification",
  101906: "Système d'agent",
  101907: "Merci.",
  101908: "Votre demande a été envoyée. Nous examinons généralement vos informations dans un délai de 2 à 3 jours ouvrables, et votre commission sera effective après avoir passé la revue !",
  //代理商拉新
  92000000: "Compte à rebours",
  92000001: "Méthode de participation",
  92000002: "Vous devez vous assurer que le compte effectuant la tâche correspond à votre compte enregistré/connecté sur la page actuelle pour avoir une chance de gagner des récompenses.",
  92000003: "Attente de vérification de tâche",
  92000004: 'Inscrivez-vous à SuperEx par invitation de <span style="color:#000922;font-weight:500;">{brokerName}</span> pour débloquer un bonus de bienvenue à durée limitée!',
  92000005: "Débuter à partir de {time}",
  92000006: "Terminer avant {time}",
  92000007: `La vérification de l'achèvement de la tâche peut prendre jusqu'à 7 jours ouvrables, veuillez être patient.`,
  92000008: `Environ 7 jours après l'événement`,
  92000009: `La récompense sera distribuée sur le compte dans les 7 jours ouvrables suivant la validation de l'événement.`,
  92000010: `S'inscrire en utilisant le lien d'invitation de <span style="color:#000922;font-weight:400;">{brokerName}</span>`,
  92000011: "Termes et conditions",
  92000012: "Activité en cours",
  92000013: "Impossible de participer à cet événement",
  92000014: "Événement terminé",
  92000015: "Réclamez votre récompense",
  92000016: "Connectez-vous maintenant",
  92000017: "Veuillez définir un surnom",

  92000018: "Remarques",
  92000019: "Ce champ est obligatoire",
  92000020: "Enregistrer",
  92000021: `Partager l'affiche`,
  92000022:'Max',
  92000023:'Éditer le canal',
  92000024:'Créer un canal affilié',
  92000025:`Pas de code d'invitation dans ce canal`,
  92000026:'',
  92000027:'',
  92000028:'',
  92000029:'',
  92000030:'',
};
export default fr;



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/fr.js